const AssetRoutes = [
    {
        path: '/staffing/employee-asset',
        component: () => import('@/views/EmployeeAsset/Staffing_EmployeeAssetView.vue'),
    },
    {
        path: '/asset/data-setup',
        name: 'asset-data-setup',
        component: () => import('@/views/EmployeeAsset/data-setup/AssetDataSetupView.vue'),
    },
    {
        path: '/asset/broken-asset',
        name: 'asset-broken',
        component: () => import('@/views/EmployeeAsset/data-setup/BrokenAssetView.vue'),
    },
    {
        path: '/asset/repair-asset',
        name: 'asset-repair',
        component: () => import('@/views/EmployeeAsset/data-setup/RepairAssetView.vue'),
    },
    // {
    //     path: '/asset/company-asset',
    //     name: 'asset-company',
    //     component: () => import('@/views/CompanyAsset/CompanyAsset.vue'),
    // },
    // {
    //     path: '/asset/department-asset',
    //     name: 'asset-department',
    //     component: () => import('@/views/DepartmentAsset/Departmentasset.vue'),
    // },
    {
        path: '/asset/report',
        name: 'asset-report',
        component: () => import('@/views/EmployeeAsset/EmployeeAssetReportView.vue'),
    },
    {
        path: '/asset/department-report',
        name: 'department-asset-report',
        component: () => import('@/views/DepartmentAsset/DepartmentAssetReportView.vue'),
    },
    {
        path: '/asset/company-report',
        name: 'company-asset-report',
        component: () => import('@/views/CompanyAsset/CompanyAssetReportView.vue'),
    },
]

export default AssetRoutes
